const eSounds = {
  EST_BACKGROUND: { soundName: 'background', volume: 0.8, group: 'music' },
  // EST_BACKGROUND_BONUS: { soundName: 'background_bonus', volume: 0.8, group: 'music' },
  EST_WIN: { soundName: 'win', volume: 0.8, group: 'winning' },
  EST_BIG_WIN: { soundName: 'big_win', volume: 0.8, group: 'winning' },
  EST_MEGA_WIN: { soundName: 'mega_win', volume: 0.9, group: 'winning' },
  EST_EPIC_WIN: { soundName: 'epic_win', volume: 1, group: 'winning' },
  EST_WIN_END: { soundName: 'win_end', volume: 0.8, group: 'winning' },
  EST_MONEY_GAIN: { soundName: 'money_gain', volume: 0.7, loop: true, group: 'winning' },
  EST_BUTTON_CLICK: { soundName: 'button_click', volume: 0, group: 'default' },
  EST_REEL_STOP: { soundName: 'reel_stop', volume: 0.7, group: 'default' },
  EST_SCATTER_STOP: { soundName: 'scatter_stop', volume: 1, group: 'default' },
};

const soundsPreloaderConfig = Object.fromEntries(Object.keys(eSounds).map(key => [key, eSounds[key].soundName]));

export {
  eSounds,
  soundsPreloaderConfig,
}
